import output from "_src/engine/output.js";
import Shader from "_src/engine/shader";
import Uniform from "_src/engine/uniform";
import { uniformType, uniformSource } from "_src/engine/constants";
import { vec2, vec4 } from "_src/libs/gl-matrix";

import vertText from "_src/shaders/selection/selection_interface.glslv";
import fragText from "_src/shaders/selection/selection_interface.glslf";

const _vec4Tmp = vec4.create();

const preprocessorRules = {
  "CIRCLE": 0,
  "RECT": 1,
};

export default class SelectionInterfaceShader extends Shader {

  constructor(params = {}) {

    super(params);

    this.attachUniforms(params);

  }

  //reimplementation
  initDirectives() {
    this._directives["MODE"] = "CIRCLE";
  }

  compile() {

    super.compile(vertText, fragText, preprocessorRules);

  }

  updateObjectUniformValues(object)   {
    vec4.copy(this.uniforms["u_diffuse"].value, object.properties.diffuseColor);
  }

  updateSceneUniformValues(scene)   {
    const camera = scene.camera;
    vec2.set(this.uniforms["u_viewport"].value, camera.viewport[2], camera.viewport[3]);
  }

  attachUniforms(params) {
    const width         = "width" in params ? params.width : 6;
    const outlineColor  = params.outlineColor !== undefined ? vec4.clone(params.outlineColor) : vec4.fromValues(1.0, 1.0, 1.0, 1.0);

    this.uniforms["u_rectangle"]      = new Uniform(uniformType.FLOAT4, vec4.create());
    this.uniforms["u_circle_pos"]     = new Uniform(uniformType.FLOAT2, vec2.create());
    this.uniforms["u_circle_radius"]  = new Uniform(uniformType.FLOAT1, 1);
    this.uniforms["u_outline_color"]  = new Uniform(uniformType.FLOAT4, outlineColor);
    this.uniforms["u_viewport"]       = new Uniform(uniformType.FLOAT2, vec2.create(), uniformSource.SCENE);

    this.uniforms["u_diffuse"]        = new Uniform(uniformType.FLOAT4, vec4.create(), uniformSource.OBJECT);
    this.uniforms["u_border_width"]   = new Uniform(uniformType.FLOAT1, width);
  }

  setRectangle(x, y, z, w) {
    const rectangle = vec4.set(_vec4Tmp, x, y, z, w);
    this.setUniform("u_rectangle", rectangle);
  }

  setSelectionRadius(radius) {
    this.uniforms["u_circle_radius"].value = radius;
  }

  setSelectionPoint(x, y) {
    vec2.set(this.uniforms["u_circle_pos"].value, x, y);
  }

  setWidth(width) {
    if (width < 8) {
      output.warn("Minimum width for selection circle shape is 8. Lower values will cause aliasing artifacts.");
    }
    this.uniforms["u_border_width"].value = width;
  }

}
